import { Styles } from 'react-jss'

export const sheet: Styles = {
  title: {},
  text: {},
  img: {},
  main: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    width: 343,
    minHeight: 110,
    background: '#FAFAFA',
    border: '1px solid #286EFA',
    boxSizing: 'border-box',
    padding: '10px 12px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 12,
    lineHeight: '16px',
    letterSpacing: '0.01em',
    color: '#565656',
    '& $text a': {
      whiteSpace: 'inherit',
      wordBreak: 'break-all'
    },
    '& > $img': {
      width: 36,
      minWidth: 36,
      height: 36,
      background: '#202332',
      boxSizing: 'border-box',
      borderRadius: '37px',
      fontWeight: '500',
      fontSize: 14,
      lineHeight: '18px',
      letterSpacing: '0.01em',
      color: '#FAFAFA',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flex: 'none'
    }
  },
  root: {
    flex: 1,
    marginLeft: 12,
    overflow: 'hidden',
    '& > p': {
      margin: 0
    },
    '& > $text > span': {
      color: '#565656',
      fontWeight: '500'
    }
  },
  unread: {
    background: '#FEFAF1'
  }
}
